<template>
  <div class="pdf-inline-preview">
    <v-file-input
      v-if="!file"
      :accept="accept"
      :disabled="disabled"
      :value="file"
      @change="onChange"
      class="v-file-input-dropzone"
      chips
      flat
      hide-details
      solo
      prepend="mdi-paper-clip"
      placeholder="Selecciona o arrastra un PDF"
      type="file"
    />
    <div v-else class="pdf-inline-preview__frame" :style="{ height: height + 'px' }">
      <iframe v-if="blobUrl" :src="blobUrl" width="100%" height="100%" style="border: 0;" />
      <div v-else class="d-flex align-center justify-center fill-height">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    file: {
      type: File,
      default: null
    },
    height: {
      type: String,
      default: '480'
    },
    accept: {
      type: String,
      default: '.pdf'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    blobUrl: null
  }),
  watch: {
    file: {
      immediate: true,
      handler (file) {
        this.revoke()
        if (file instanceof File) {
          this.blobUrl = URL.createObjectURL(file)
        } else {
          this.blobUrl = null
        }
      }
    }
  },
  beforeDestroy () {
    this.revoke()
  },
  methods: {
    onChange (file) {
      this.$emit('input', file || null)
    },
    revoke () {
      if (this.blobUrl) {
        URL.revokeObjectURL(this.blobUrl)
        this.blobUrl = null
      }
    }
  }
}
</script>
<style scoped>
.pdf-inline-preview__frame {
  background: #f5f5f5;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: hidden;
}
</style>
